// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-line-number {
  width: 100%;
}
.input-line-number .input-text-form-component {
  max-width: 13rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/fields/v2/PhoneNumberForm/LineNumber/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EACE,gBAAA;AACJ","sourcesContent":[".input-line-number {\n  width: 100%;\n\n  .input-text-form-component {\n    max-width: 13rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
